import { IGameProvider, IGameSession, IGame, IGameCategory, TAB_SECTION, IGameActivity } from '@libs/interfaces';
import { createAction, props } from '@ngrx/store';
import { GAME_SCREEN_LAYOUT, IGrigGameSession, SCREEN_GRID_TYPE } from './model';

export const addCategorySearchGames = createAction(
  '[Game Session] Add category searcher games',
  props<{ categorySearchGames: IGame[] }>(),
);
export const addGamesProviders = createAction(
  '[Game Session] Add game providers',
  props<{ gamesProviders: IGameProvider[] }>(),
);
export const removeSession = createAction('[Game Session] Remove session', props<{ index: number }>());
export const toggleGameType = createAction('[Game Session] Toggle game type');
export const toggleFullScreen = createAction('[Game Session] Toggle full screen');
export const setFullScreen = createAction('[Game Session] set full screen', props<{ fullscreen: boolean }>());
export const addGamesCategories = createAction(
  '[Game Session] Add game categories',
  props<{ categories: IGameCategory[] }>(),
);
export const addGamesCategory = createAction(
  '[Game Session] Add games category',
  props<{ games: IGame[]; section: TAB_SECTION }>(),
);
export const addGamesActivities = createAction(
  '[Game Session] Add games activities',
  props<{ activity: IGameActivity[] }>(),
);
export const addGamesActivity = createAction('[Game Session] Add games activity', props<{ activity: IGameActivity }>());
export const setGameScreenLayout = createAction(
  '[Game Session] Set game screen layout',
  props<{ game_screen_layout: GAME_SCREEN_LAYOUT }>(),
);
export const addSession = createAction('[Game Session] Add session', props<{ session: IGameSession }>());
export const addGame = createAction('[Game Session] Add game', props<{ game: IGame }>());

export const addGridGameSession = createAction(
  '[Game Session] Add grid game session',
  props<{ index: number; gridGameSession: IGrigGameSession }>(),
);
export const removeGridGameSession = createAction(
  '[Game Session] Remove grid game session',
  props<{ index: number }>(),
);
export const setSelectedIndex = createAction('[Game Session] Set selected index', props<{ selectedIndex: number }>());
export const setDesktop = createAction('[Game Session] Set desktop', props<{ desktop: SCREEN_GRID_TYPE }>());
export const setShowGamesTree = createAction('[Game Session] Set show games tree', props<{ showGamesTree: boolean }>());
export const toggleShowGamesTree = createAction('[Game Session] Toggle show games tree');
export const setGame = createAction('[Game Session] Set game', props<{ game: IGame }>());
